import React from "react";

/** ================================
 * Arrow Marker
 ================================ */
export interface ArrowMarkerProps {
  id: string;
  xOffset?: number;
  color?: string;
  opacity?: number;
}

export const ArrowMarker = ({ id, xOffset = 8.5, color = "#000", opacity = 1 }: ArrowMarkerProps) => {
  return (
    <defs>
      <marker
        id={`arrow-${id}`}
        viewBox="0 0 10 10"
        refX={xOffset}
        refY="4.5"
        markerWidth="11"
        markerHeight="11"
        fill={color}
        orient="auto-start-reverse"
        opacity={opacity}
      >
        <path d="M 0 0 L 10 4.5 L 0 9 L 2.5 4.5 Z" />
      </marker>
    </defs>
  );
};

/** ================================
 * Block Marker
 ================================ */
export interface BlockMarkerProps {
  id: string;
  height?: number;
  color?: string;
  opacity?: number;
}

export const BlockMarker = ({ id = "screen", color = "#000", height = 11, opacity = 1 }: BlockMarkerProps) => {
  return (
    <defs>
      <marker
        id={`block-${id}`}
        viewBox="0 0 50 50"
        refX="0"
        refY={`${height / 2}`}
        markerWidth="50"
        markerHeight="50"
        fill={color}
        orient="auto-start-reverse"
        opacity={opacity}
      >
        <rect width={1} height={height} />
      </marker>
    </defs>
  );
};

/** ================================
 * Hash Marker
 ================================ */
export interface HashpassMarkerProps {
  id: string;
  numberOfHashes: number;
  isStraight: boolean;
}

export const HashpassMarker = ({ id, numberOfHashes, isStraight }: HashpassMarkerProps) => {
  const hashes = Array(numberOfHashes)
    .fill(0)
    .map((_d, i): number => {
      const side = i % 2 === 1 ? -1 : 1;
      return Math.round(i / 2) * side * 3;
    });

  return (
    <defs>
      <marker
        id={`hashpass-${isStraight ? "STRAIGHT" : "PATH"}-${numberOfHashes}-${id}`}
        viewBox="-6 0 50 50"
        refX={isStraight ? "3" : "0"}
        refY="4"
        markerWidth="50"
        markerHeight="50"
        orient="auto-start-reverse"
      >
        {hashes.map((hash, key) => (
          <rect x={hash} y="0" width={1} height={8} fill="#000" key={key} />
        ))}
      </marker>
    </defs>
  );
};
